import { Paginacao } from "../util/paginacao";
import { Equipamento } from "./Equipamentos";

export class Fornecedor{
    
    fornecedorId: string;
    idPorte: number;
    idCapitalSocial: number;
    robValor: number;
    robGrupoValor: number;
    robData: Date;
    robGrupoData: Date;
    dataDeConstituicao: Date;
    logradouro: string;
    bairro: string;
    municipio: string;
    uf: string;
    cep: string;
    nomCapitalSocial: string;
    cnpj: string;
    nome: string;
    naturezaDaEmpresa: string;
    nomPorte: string;
    robTipo: string;
    cnpjLiderGrupo: string;
    robGrupoTipo: string;

    capitalSocialId: string;
    capitalSocialNome: string;
    porteId: string;
    porteNome: string;
    indAtividadeDecreto: string;
    grupoCnpjLider: string;
    grupoRobTipo: string;
    grupoRobValor: number;
    grupoRobData: Date;

    equipamentosList : Equipamento[] = [];
    paginacaoEquipamentos: Paginacao<Equipamento> = new Paginacao([5,10,20]);

    get paginacao(): Paginacao<Equipamento> {       
        this.paginacaoEquipamentos.atualizarItens(this.equipamentosList);
        return this.paginacaoEquipamentos;
    }
}